import React from 'react';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}
export function Logo({
  size = 'md',
  className = ''
}: LogoProps) {
  const sizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl'
  };
  return <div className={`font-serif font-bold tracking-tight ${sizeClasses[size]} ${className}`} data-id="element-34" data-mp="3qb5t8ho2o9h2">
      <span className="text-white" data-id="element-35" data-mp="3v8xlxdwjjzmb">Geniac</span>
      <span className="text-amber" data-id="element-36" data-mp="mscngr1jcoxg">.io</span>
    </div>;
}